module.exports = __webpack_public_path__ + "img/110053.b60312d9.png";